module.exports = __webpack_public_path__ + "img/apropos_logo.dbaef157.svg";